<template>
    <div>
        <facetList :game_id="game_id"></facetList>
    </div>
</template>

<script>

import facetList from '@/components/games/facet/list.vue';

export default {
    components: {
        facetList
    },
    data () {
        let self = (window.x = this)
        return {
            game_id: 3,
        }
    },
    methods: {
    },
    mounted () {
    },
    watch: {},
    computed: {}
}
</script>